/**
 * TallyEmbed hook
 * 
 * Loads and initializes Tally form embeds in Phoenix LiveView.
 * The hook loads the Tally embed script and initializes any iframes with data-tally-src attributes.
 */
export const TallyEmbed = {
  mounted() {
    this.loadTally();
  },

  updated() {
    // Re-initialize Tally if the element is updated
    this.loadTally();
  },

  loadTally() {
    const scriptUrl = "https://tally.so/widgets/embed.js";
    
    // Check if Tally is already loaded
    if (typeof window.Tally !== "undefined") {
      window.Tally.loadEmbeds();
      return;
    }

    // Check if script is already being loaded
    if (document.querySelector(`script[src="${scriptUrl}"]`)) {
      return;
    }

    // Load the Tally script
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.onload = () => {
      if (typeof window.Tally !== "undefined") {
        window.Tally.loadEmbeds();
      }
    };
    script.onerror = () => {
      console.error("Failed to load Tally embed script");
      // Fallback: manually set iframe src from data-tally-src
      this.fallbackLoadEmbeds();
    };
    
    document.body.appendChild(script);
  },

  fallbackLoadEmbeds() {
    // Fallback method if Tally script fails to load
    document.querySelectorAll("iframe[data-tally-src]:not([src])").forEach((iframe) => {
      iframe.src = iframe.dataset.tallySrc;
    });
  },

  destroyed() {
    // Clean up if needed
  }
};
